export default "__VITE_ASSET__BfeCSPCP__"